import isEmpty from 'ramda/src/isEmpty';

export const orderArrayByParams = (array: any[], byOrder: any, propName: any) => {
  if (array && !isEmpty(array)) {
    const arrayForSort = [...array];
    const orderList = arrayForSort.sort((a, b) => {
      if (byOrder === 'asc') {
        return a[propName] - b[propName];
      } else {
        return b[propName] - a[propName];
      }
    });
    return orderList;
  } else {
    return [];
  }
};

export const hasDevicesOfType = (devices: any[], deviceTypes: string[]): boolean => {
  if (!devices?.length || !deviceTypes.length) return false;

  const typeSet = new Set(deviceTypes);

  return devices.some(({ type }) => typeSet.has(type.code));
};

export const filterArchived = (list: any[]) => {
  return list?.filter((item: { archived: any }) => !item.archived).map((item: any) => ({ ...item }));
};

export const filterByInstaller = (list: any[], installerPermissions: any) => {

  if (!installerPermissions){
    return list.filter((item: { code: any }) => (item.code !== 'PENDING_INSTALLATION' && item.code !== 'ACTIVE' && item.code !== 'ARCHIVED')).map((item: any) => ({ ...item }));
  } else {
    return list;
  }
};

// Regla de la rama "Pausa": a ABSENT solo se entra desde ACTIVE, y desde ABSENT
// solo se puede volver a ACTIVE. El backend (gdp-api) aplica la misma regla de forma
// estricta; esto es el filtro de visibilidad del desplegable Estado.
export const filterByTransition = (list: any[], currentCode: any) => {
  if (currentCode === 'ABSENT') {
    return list?.filter((item: { code: any }) => item.code === 'ACTIVE').map((item: any) => ({ ...item }));
  }
  if (currentCode !== 'ACTIVE') {
    return list?.filter((item: { code: any }) => item.code !== 'ABSENT').map((item: any) => ({ ...item }));
  }
  return list;
};
